import {
  deriveDexaRecord,
  isFiniteNumber,
  round,
  toFiniteNumber,
} from "./dexaCalculations.js";

export const interpretationSources = [
  {
    id: "nhanes-total-2009",
    label: "Kelly et al. · Referencias de composición corporal NHANES",
    url: "https://doi.org/10.1371/journal.pone.0007038",
    apa: "Kelly, T. L., Wilson, K. E., & Heymsfield, S. B. (2009). Dual energy X-ray absorptiometry body composition reference values from NHANES. PLOS ONE, 4(9), e7038. https://doi.org/10.1371/journal.pone.0007038",
  },
  {
    id: "nhanes-regional-2017",
    label: "Hinton et al. · Referencias regionales NHANES 1999-2004",
    url: "https://doi.org/10.1371/journal.pone.0174180",
    apa: "Hinton, B. J., Fan, B., Ng, B. K., & Shepherd, J. A. (2017). Dual energy X-ray absorptiometry body composition reference values of limbs and trunk from NHANES 1999-2004 with additional visualization methods. PLOS ONE, 12(3), e0174180. https://doi.org/10.1371/journal.pone.0174180",
  },
  {
    id: "iscd-2023",
    label: "ISCD · Official Adult Positions 2023",
    url: "https://iscd.org/official-positions-2023/",
    apa: "International Society for Clinical Densitometry. (2023). Official adult positions 2023. https://iscd.org/official-positions-2023/",
  },
  {
    id: "iscd-pediatric-2019",
    label: "ISCD · Official Pediatric Positions 2019",
    url: "https://iscd.org/text-pediatric-positions/",
    apa: "International Society for Clinical Densitometry. (2019). Official pediatric positions. https://iscd.org/text-pediatric-positions/",
  },
  {
    id: "hologic-horizon",
    label: "Hologic · Horizon Bone Densitometry System User Guide",
    url: "https://www.hologic.com/system/files/2020-03/Horizon%20User%20Guide%20%28MAN-04871%29%20English%20Rev_011%2001-2020.pdf",
    apa: "Hologic, Inc. (2020). Horizon bone densitometry system user guide (MAN-04871, Rev. 011).",
  },
  {
    id: "iscd-body-composition",
    label: "ISCD · Body Composition Analysis Reporting",
    url: "https://pubmed.ncbi.nlm.nih.gov/24183640/",
    apa: "Petak, S., Barbu, C. G., Yu, E. W., Fielding, R., Mulligan, K., Sabowitz, B., Wu, C.-H., & Shepherd, J. A. (2013). The official positions of the International Society for Clinical Densitometry: Body composition analysis reporting. Journal of Clinical Densitometry, 16(4), 508-519. https://doi.org/10.1016/j.jocd.2013.08.018",
  },
  {
    id: "nana-dxa-athletes-2015",
    label: "Nana et al. · Metodología DXA en deportistas",
    url: "https://doi.org/10.1123/ijsnem.2013-0228",
    apa: "Nana, A., Slater, G. J., Stewart, A. D., & Burke, L. M. (2015). Methodology review: Using dual-energy X-ray absorptiometry (DXA) for the assessment of body composition in athletes and active people. International Journal of Sport Nutrition and Exercise Metabolism, 25(2), 198-215. https://doi.org/10.1123/ijsnem.2013-0228",
  },
  {
    id: "android-gynoid-lipids-2015",
    label: "Min y Min · Distribución androide/ginoide y perfil lipídico",
    url: "https://doi.org/10.1111/cen.12505",
    apa: "Min, K.-B., & Min, J.-Y. (2015). Android and gynoid fat percentages and serum lipid levels in United States adults. Clinical Endocrinology, 82(3), 377-387. https://doi.org/10.1111/cen.12505",
  },
  {
    id: "ofenheimer-vat-2020",
    label: "Ofenheimer et al. · Masa de tejido adiposo visceral por edad y sexo",
    url: "https://doi.org/10.1038/s41430-020-0596-5",
    apa: "Ofenheimer, A., Breyer-Kohansal, R., Hartl, S., Burghuber, O. C., Krach, F., Schrott, A., Wouters, E. F. M., Franssen, F. M. E., & Breyer, M.-K. (2020). Reference values of body composition parameters and visceral adipose tissue (VAT) by DXA in adults aged 18-81 years: Results from the LEAD cohort. European Journal of Clinical Nutrition, 74(8), 1181-1191. https://doi.org/10.1038/s41430-020-0596-5",
  },
  {
    id: "ewgsop2",
    label: "EWGSOP2 · Consenso europeo revisado sobre sarcopenia",
    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC6322506/",
    apa: "Cruz-Jentoft, A. J., et al. (2019). Sarcopenia: Revised European consensus on definition and diagnosis. Age and Ageing, 48(1), 16-31. https://doi.org/10.1093/ageing/afy169",
  },
  {
    id: "acsm-body-composition",
    label: "ACSM · Fitness Categories for Body Composition",
    url: "https://www.acsm.org/docs/default-source/publications-files/getp10_tables-4-4-4-5-updated.pdf",
    apa: "American College of Sports Medicine. (2019). Fitness categories for body composition (% body fat): Updates to Tables 4.4 and 4.5. https://www.acsm.org/docs/default-source/publications-files/getp10_tables-4-4-4-5-updated.pdf",
  },
  {
    id: "exercise-bone-consensus",
    label: "Consenso sobre ejercicio, fuerza y salud ósea",
    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC9304091/",
    apa: "Brooke-Wavell, K., et al. (2022). Strong, steady and straight: UK consensus statement on physical activity and exercise for osteoporosis. British Journal of Sports Medicine, 56(15), 837-846. https://doi.org/10.1136/bjsports-2021-104634",
  },
  {
    id: "messina-dxa-2020",
    label: "Messina et al. · Composición corporal e índices DXA",
    url: "https://doi.org/10.21037/qims.2020.03.02",
    apa: "Messina, C., Albano, D., Gitto, S., Tofanelli, L., Bazzocchi, A., Ulivieri, F. M., Guglielmi, G., & Sconfienza, L. M. (2020). Body composition with dual energy X-ray absorptiometry: From basics to new tools. Quantitative Imaging in Medicine and Surgery, 10(8), 1687-1698. https://doi.org/10.21037/qims.2020.03.02",
  },
  {
    id: "who-bmi-adults",
    label: "OMS · Clasificación del índice de masa corporal en adultos",
    url: "https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight",
    apa: "World Health Organization. (2025). Obesity and overweight. https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight",
  },
];

function format(value, digits = 1, suffix = "") {
  const numeric = toFiniteNumber(value);
  return numeric !== null
    ? `${numeric.toLocaleString("es-CO", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    })}${suffix}`
    : "Pendiente";
}

function classifyBmi(bmi, age) {
  const value = toFiniteNumber(bmi);
  const patientAge = toFiniteNumber(age);
  if (value === null) {
    return { value: null, classification: "Pendiente", mode: "unavailable" };
  }
  if (patientAge === null) {
    return { value, classification: "Edad pendiente", mode: "age-required" };
  }
  if (patientAge < 18) {
    return { value, classification: "Interpretación por edad y sexo", mode: "pediatric" };
  }
  if (value < 18.5) return { value, classification: "Bajo peso", mode: "adult" };
  if (value < 25) return { value, classification: "Peso normal", mode: "adult" };
  if (value < 30) return { value, classification: "Sobrepeso", mode: "adult" };
  if (value < 35) return { value, classification: "Obesidad clase I", mode: "adult" };
  if (value < 40) return { value, classification: "Obesidad clase II", mode: "adult" };
  return { value, classification: "Obesidad clase III", mode: "adult" };
}

function bodyFatReference(sex, age, profile) {
  if (!isFiniteNumber(age)) return null;
  const older = Number(age) >= 40;
  if (profile === "athlete") {
    if (sex === "female") return older ? [20, 33] : [16, 28];
    if (sex === "male") return older ? [7, 18] : [5, 15];
  }
  if (profile === "general") {
    if (sex === "female") return older ? [25, 38] : [20, 35];
    if (sex === "male") return older ? [10, 25] : [8, 22];
  }
  return null;
}

function leanPercentReference(sex, age, profile) {
  if (!isFiniteNumber(age)) return null;
  const older = Number(age) >= 40;
  if (profile === "athlete") {
    if (sex === "female") return older ? [67, 80] : [72, 84];
    if (sex === "male") return older ? [92, 93] : [85, 95];
  }
  if (profile === "general") {
    if (sex === "female") return older ? [62, 75] : [65, 80];
    if (sex === "male") return older ? [75, 90] : [78, 92];
  }
  return null;
}

function bodyFatReferenceRow(sex, age, profile, value) {
  const numeric = toFiniteNumber(value);
  const numericAge = toFiniteNumber(age);
  if (numeric === null || numericAge === null) return null;
  if (!["female", "male"].includes(sex) || !["athlete", "general"].includes(profile)) return null;
  const older = numericAge >= 40;
  const lowLimit = sex === "female" ? 14 : 5;
  const obesityLimit = sex === "female"
    ? older ? 38 : 35
    : older ? 25 : 22;
  if (numeric < lowLimit) return "underfat";
  if (numeric > obesityLimit) return "obesity";
  return `${profile}-${older ? "older" : "younger"}`;
}

function classifyAgainstRange(value, range) {
  if (!isFiniteNumber(value) || !range) return { id: "unavailable", label: "Sin clasificar" };
  if (Number(value) < range[0]) return { id: "below", label: "Por debajo del rango de referencia" };
  if (Number(value) > range[1]) return { id: "above", label: "Por encima del rango de referencia" };
  return { id: "within", label: "Dentro del rango de referencia" };
}

function percentileSentence(percentile, subject, record) {
  if (!isFiniteNumber(percentile)) return "";
  const value = Math.max(0, Math.min(100, Math.round(Number(percentile))));
  const group = record?.patient?.sex === "female"
    ? "mujeres"
    : record?.patient?.sex === "male"
      ? "hombres"
      : "personas";
  return `${subject}: alrededor de un ${value}% de ${group} de la misma edad presenta un valor inferior.`;
}

function differenceInterpretation(comparison, segment, leftRegion, rightRegion, record) {
  const metric = comparison?.totalMassG;
  if (!metric) {
    return {
      status: "unavailable",
      title: `${segment}: datos pendientes`,
      text: "Faltan valores bilaterales para calcular la diferencia.",
    };
  }
  const percent = metric.differencePercent;
  const symmetrical = metric.absoluteDifference <= 500;
  const greaterRegion = metric.difference >= 0 ? leftRegion : rightRegion;
  const otherRegion = metric.difference >= 0 ? rightRegion : leftRegion;
  const percentile = percentileSentence(
    greaterRegion?.percentileAgeMatched ?? otherRegion?.percentileAgeMatched,
    "En esta región corporal",
    record,
  );
  const greaterSide = metric.greaterSide.toLocaleLowerCase("es");
  const matchingComponents = [
    ["masa magra", comparison.leanMassG],
    ["tejido graso", comparison.fatMassG],
  ].filter(([, component]) => component?.greaterSide === metric.greaterSide && component.absoluteDifference >= 1);
  const componentText = matchingComponents.length === 2
    ? "corresponde tanto a masa magra como a tejido graso"
    : matchingComponents.length === 1
      ? `corresponde principalmente a ${matchingComponents[0][0]}`
      : "no muestra un predominio coincidente de masa magra o tejido graso";
  return {
    status: symmetrical ? "favorable" : "review",
    title: symmetrical ? `${segment}: adecuada simetría` : `${segment}: asimetría evidente`,
    text: `${symmetrical ? "La diferencia total es mínima" : "La diferencia total es significativa"}: ${format(metric.absoluteDifference, 0, " g")} (${format(percent, 1, "%")}). ${metric.absoluteDifference < 1 ? "No se identifica predominio de un lado." : `El mayor valor total se encuentra en ${greaterSide} y ${componentText}.`}${percentile ? ` ${percentile}` : ""}`,
  };
}

function bodyTissueLevel(classification) {
  if (classification?.id === "below") return "baja";
  if (classification?.id === "above") return "alta";
  if (classification?.id === "within") return "adecuada";
  return "no determinada";
}

function classifyVatArea(value) {
  const numeric = toFiniteNumber(value);
  if (numeric === null) return { id: "unavailable", label: "Pendiente", status: "unavailable" };
  if (numeric < 10) return { id: "below-scale", label: "Por debajo de la escala configurada", status: "favorable" };
  if (numeric <= 100) return { id: "normal", label: "Normal", status: "favorable" };
  if (numeric <= 160) return { id: "increased", label: "Aumentado", status: "attention" };
  return { id: "high", label: numeric <= 300 ? "Alto" : "Por encima de la escala", status: "review" };
}

function classifyFmi(value, sex) {
  if (!isFiniteNumber(value)) return { status: "unavailable", label: "Pendiente", note: "" };
  const ranges = sex === "female"
    ? { normal: [5, 9], overweight: 13, class1: 17, class2: 21 }
    : sex === "male"
      ? { normal: [3, 6], overweight: 9, class1: 12, class2: 15 }
      : null;
  if (!ranges) return { status: "unavailable", label: "Lectura descriptiva", note: `IMG actual: ${format(value, 2, " kg/m²")}. Confirma el sexo de referencia.` };
  const numeric = Number(value);
  const [min, max] = ranges.normal;
  if (numeric < min) {
    return {
      status: "attention",
      label: "Bajo contenido de masa grasa",
      note: `El IMG es ${format(value, 2, " kg/m²")}, por debajo del intervalo normal para ${sex === "female" ? "mujeres" : "hombres"} (${min}-${max} kg/m²).`,
    };
  }
  if (numeric <= max) {
    return {
      status: "favorable",
      label: "Contenido de masa grasa dentro de referencia",
      note: `El IMG es ${format(value, 2, " kg/m²")}, dentro del intervalo normal para ${sex === "female" ? "mujeres" : "hombres"} (${min}-${max} kg/m²).`,
    };
  }
  const category = numeric <= ranges.overweight
    ? "sobrepeso"
    : numeric <= ranges.class1
      ? "obesidad clase I"
      : numeric <= ranges.class2
        ? "obesidad clase II"
        : "obesidad clase III";
  return {
    status: numeric > ranges.class2 ? "review" : "attention",
    label: `IMG en categoría de ${category}`,
    note: `El IMG es ${format(value, 2, " kg/m²")}, correspondiente a la categoría de ${category} para ${sex === "female" ? "mujeres" : "hombres"}.`,
  };
}

function classifyTrunkExtremity(value) {
  const numeric = toFiniteNumber(value);
  if (numeric === null) return { status: "unavailable", label: "Pendiente", note: "" };
  if (numeric <= 1) {
    return {
      status: "favorable",
      label: "Proporción tronco/extremidades óptima",
      note: `La proporción de grasa en tronco con relación a las extremidades es óptima (${format(numeric, 2)}).`,
    };
  }
  return {
    status: "attention",
    label: "Mayor concentración relativa en tronco",
    note: `No hay una proporción óptima de grasa entre tronco y extremidades (${format(numeric, 2)}): predomina la grasa del tronco, distribución que merece valoración cardiometabólica junto con los demás datos clínicos.`,
  };
}

function musclePercentileInterpretation(value, percentile, label, options = {}) {
  if (!isFiniteNumber(value)) {
    return { status: "unavailable", title: `${label}: pendiente`, note: "Falta el valor del índice." };
  }
  const numeric = Number(value);
  const p = toFiniteNumber(percentile);
  const cutoff = toFiniteNumber(options.cutoff);
  const riskCutoff = toFiniteNumber(options.riskCutoff);
  const percentileDetail = p === null
    ? "El equipo no informó un percentil comparable para edad y sexo."
    : `Referencia comparativa: percentil EC ${format(p, 0)}.`;

  if (riskCutoff !== null && numeric <= riskCutoff) {
    return {
      status: "review",
      title: `${label} ${format(value, 2, " kg/m²")} · Riesgo de sarcopenia`,
      note: `El valor es menor o igual al umbral operativo de riesgo de ${format(riskCutoff, 1, " kg/m²")}. Este hallazgo requiere énfasis y valoración prioritaria de fuerza muscular y desempeño físico. La masa magra aislada no confirma el diagnóstico de sarcopenia. ${percentileDetail}`,
    };
  }

  if (cutoff !== null && numeric < cutoff) {
    return {
      status: "attention",
      title: `${label} ${format(value, 2, " kg/m²")} · Por debajo del mínimo`,
      note: `El valor está por debajo del mínimo operativo de ${format(cutoff, 1, " kg/m²")}. Se considera masa magra relativa baja y debe analizarse junto con fuerza, desempeño físico, edad y contexto clínico. ${percentileDetail}`,
    };
  }

  if (p === null) {
    return {
      status: cutoff === null ? "unavailable" : "favorable",
      title: `${label} ${format(value, 2, " kg/m²")}`,
      note: `${cutoff === null ? "" : `El valor cumple el mínimo operativo de ${format(cutoff, 1, " kg/m²")}. `}${percentileDetail}`,
    };
  }
  let category = "desarrollo muscular dentro del rango intermedio";
  let status = "favorable";
  if (p < 10) {
    category = "desarrollo muscular muy bajo en comparación con la referencia";
    status = "review";
  } else if (p < 25) {
    category = "desarrollo muscular por debajo del rango intermedio";
    status = "attention";
  } else if (p < 35) {
    category = "desarrollo muscular normal, hacia el límite inferior";
  } else if (p > 90) {
    category = "desarrollo muscular alto frente a la referencia";
  } else if (p > 75) {
    category = "desarrollo muscular por encima del rango intermedio";
  }
  return {
    status,
    title: `${label} ${format(value, 2, " kg/m²")} · percentil ${format(p, 0)}`,
    note: `El valor indica ${category} para la edad y el sexo de referencia (referencia comparativa: percentil EC ${format(p, 0)}${cutoff !== null ? `; mínimo operativo ${format(cutoff, 1, " kg/m²")}` : ""}).${options.explainPercentile ? " En estos índices, un percentil más alto representa mayor masa magra relativa." : ""}`,
  };
}

function selectBoneMode(record) {
  const age = toFiniteNumber(record.patient.age);
  const sex = record.patient.sex;
  const menopause = record.professional.menopausalStatus;
  if (age === null || !["female", "male"].includes(sex)) return "review";
  if (sex === "female") {
    if (menopause === "postmenopausal") return "t";
    if (menopause === "premenopausal") return "z";
    return age >= 50 ? "review" : "z";
  }
  if (sex === "male") return age >= 50 ? "t" : "z";
  return age >= 50 ? "review" : "z";
}

function lowestCentralScore(record, scoreField) {
  const candidates = [
    ["Cuello femoral", record.bone.hip.neck?.[scoreField]],
    ["Cadera total", record.bone.hip.total?.[scoreField]],
    ["Columna L1-L4", record.bone.lumbar.total?.[scoreField]],
  ].filter(([, value]) => isFiniteNumber(value));
  if (!candidates.length) return null;
  return candidates.reduce((lowest, current) => (
    Number(current[1]) < Number(lowest[1]) ? current : lowest
  ));
}

function boneInterpretation(record) {
  const age = toFiniteNumber(record.patient.age);
  const mode = selectBoneMode(record);
  if (mode === "review") {
    return {
      status: "attention",
      mode,
      title: "Confirma el criterio de puntuación",
      text: "Por edad y sexo se necesita confirmar el estado menopáusico para decidir si la lectura principal usa T-score o Z-score.",
      score: null,
      site: "",
    };
  }
  const scoreField = mode === "t" ? "tScore" : "zScore";
  const lowest = lowestCentralScore(record, scoreField);
  if (!lowest) {
    return {
      status: "unavailable",
      mode,
      title: "Densidad ósea pendiente",
      text: "No hay puntuaciones centrales suficientes para una lectura.",
      score: null,
      site: "",
    };
  }
  const [site, score] = lowest;
  if (mode === "z") {
    const below = Number(score) <= -2;
    if (age !== null && age < 20) {
      return {
        status: below ? "review" : "favorable",
        mode,
        title: below ? "Masa o densidad mineral ósea baja para la edad" : "Dentro de lo esperado para la edad",
        text: below
          ? `La puntuación Z más baja es ${format(score, 1)} en ${site}. En informes pediátricos, ISCD usa “masa o densidad mineral ósea baja” para Z-score ≤ -2,0. Este resultado por sí solo no diagnostica osteoporosis y requiere revisar antecedentes de fractura y crecimiento.`
          : `La puntuación Z más baja es ${format(score, 1)} en ${site}. En población pediátrica se informa Z-score; un valor superior a -2,0 está dentro de lo esperado para la edad. No se aplican categorías diagnósticas basadas en T-score.`,
        score,
        site,
      };
    }
    return {
      status: below ? "review" : "favorable",
      mode,
      title: below ? "Por debajo de lo esperado para la edad" : "Dentro de lo esperado para la edad",
      text: `La puntuación Z más baja es ${format(score, 1)} en ${site}. En adultos jóvenes, ISCD recomienda interpretar principalmente Z-score; un valor ≤ -2,0 se considera por debajo de lo esperado para la edad.`,
      score,
      site,
    };
  }
  let status = "favorable";
  let title = "Densidad mineral ósea en rango normal";
  if (Number(score) <= -2.5) {
    status = "review";
    title = "Puntuación densitométrica compatible con osteoporosis";
  } else if (Number(score) < -1) {
    status = "attention";
    title = "Puntuación densitométrica de masa ósea baja";
  }
  return {
    status,
    mode,
    title,
    text: `La puntuación T más baja es ${format(score, 1)} en ${site}. La clasificación requiere validar edad, menopausia, calidad del escaneo, artefactos y contexto clínico.`,
    score,
    site,
  };
}

function regionalBmdInterpretations(record) {
  if (!record.professional.useWorkbookRegionalBmdRules) return [];
  const minimum = toFiniteNumber(record.professional.regionalBmdReferenceMin) ?? 0.97;
  const maximum = toFiniteNumber(record.professional.regionalBmdReferenceMax) ?? 1.28;
  const rules = [
    ["Brazos", [
      record.bone.wholeBodyRegions.leftArm?.bmd,
      record.bone.wholeBodyRegions.rightArm?.bmd,
    ]],
    ["Costillas", [
      record.bone.wholeBodyRegions.leftRibs?.bmd,
      record.bone.wholeBodyRegions.rightRibs?.bmd,
    ]],
    ["Columna dorsal", [record.bone.wholeBodyRegions.thoracicSpine?.bmd]],
    ["Columna lumbar regional", [record.bone.wholeBodyRegions.lumbarSpine?.bmd]],
    ["Pelvis", [record.bone.wholeBodyRegions.pelvis?.bmd]],
    ["Piernas", [
      record.bone.wholeBodyRegions.leftLeg?.bmd,
      record.bone.wholeBodyRegions.rightLeg?.bmd,
    ]],
  ];
  return rules.map(([label, values]) => {
    const valid = values.filter((value) => isFiniteNumber(value)).map(Number);
    const average = valid.length === values.length
      ? valid.reduce((sum, value) => sum + value, 0) / valid.length
      : null;
    const status = Number.isFinite(average)
      ? average < minimum ? "attention" : average > maximum ? "neutral" : "favorable"
      : "unavailable";
    return {
      label,
      value: average,
      threshold: minimum,
      minimum,
      maximum,
      status,
      classification: Number.isFinite(average)
        ? average < minimum
          ? "Por debajo del límite inferior"
          : average > maximum
            ? "Por encima del intervalo de referencia"
            : "Dentro del intervalo de referencia"
        : "Pendiente",
    };
  });
}

function regionalBmdRows(record) {
  const minimum = toFiniteNumber(record.professional.regionalBmdReferenceMin) ?? 0.97;
  const maximum = toFiniteNumber(record.professional.regionalBmdReferenceMax) ?? 1.28;
  const rows = [
    ["leftArm", "Brazo izquierdo", "arms"],
    ["rightArm", "Brazo derecho", "arms"],
    ["leftRibs", "Costillas izquierdas", "spine"],
    ["rightRibs", "Costillas derechas", "spine"],
    ["thoracicSpine", "Columna dorsal", "spine"],
    ["lumbarSpine", "Columna lumbar", "spine"],
    ["pelvis", "Pelvis", "lower"],
    ["leftLeg", "Pierna izquierda", "lower"],
    ["rightLeg", "Pierna derecha", "lower"],
  ];
  return rows.map(([key, label, exerciseGroup]) => {
    const value = toFiniteNumber(record.bone.wholeBodyRegions[key]?.bmd);
    return {
      key,
      label,
      exerciseGroup,
      value,
      status: value === null
        ? "unavailable"
        : value < minimum ? "attention" : value > maximum ? "neutral" : "favorable",
      classification: value === null
        ? "Pendiente"
        : value < minimum
          ? "Por debajo del límite inferior"
          : value > maximum
            ? "Por encima del intervalo"
            : "Dentro del intervalo",
    };
  });
}

function regionalExerciseRecommendations(rows) {
  const attentionRows = rows.filter((row) => row.status === "attention");
  if (!attentionRows.length) {
    return "El análisis regional no identifica segmentos por debajo del límite inferior operativo configurado. Se recomienda mantener el seguimiento conjunto con el contexto clínico, nutricional y deportivo.";
  }
  const segments = attentionRows.map((row) => row.label.toLocaleLowerCase("es"));
  const listedSegments = segments.length === 1
    ? segments[0]
    : `${segments.slice(0, -1).join(", ")} y ${segments.at(-1)}`;
  return `El análisis regional permite detectar hallazgos que podrían pasar inadvertidos al revisar únicamente la DMO total. Se identifican valores por debajo del límite operativo en ${listedSegments}; esto orienta a valorar trabajo adicional de fuerza y carga en los segmentos señalados. La selección, progresión y seguridad de los ejercicios debe ser definida de manera coordinada por las áreas de entrenamiento deportivo y fisioterapia, considerando antecedentes, tolerancia y riesgo de lesión.`;
}

function scoreSiteInterpretation(site, label, mode, { diagnosticSite = true } = {}) {
  const scoreField = mode === "t" ? "tScore" : "zScore";
  const scoreLabel = mode === "t" ? "T-score" : "Z-score";
  const score = toFiniteNumber(site?.[scoreField]);
  const bmd = toFiniteNumber(site?.bmd);
  if (score === null) {
    return {
      status: "unavailable",
      title: `${label}: lectura pendiente`,
      text: `DMO: ${format(bmd, 3, " g/cm²")}. El equipo no informó ${scoreLabel} para esta región.`,
    };
  }
  if (mode === "z") {
    const low = score <= -2;
    return {
      status: low ? "review" : "favorable",
      title: `${label}: ${scoreLabel} ${format(score, 1)}`,
      text: `DMO: ${format(bmd, 3, " g/cm²")}. El Z-score ${low ? "está por debajo de lo esperado" : "está dentro de lo esperado"} para la edad y el sexo${diagnosticSite ? "" : "; esta puntuación de cuerpo entero es comparativa y no sustituye la clasificación diagnóstica de cadera o columna"}.`,
    };
  }
  if (score <= -2.5) {
    return {
      status: "review",
      title: `${label}: ${scoreLabel} ${format(score, 1)}`,
      text: `DMO: ${format(bmd, 3, " g/cm²")}. El T-score se encuentra en el intervalo densitométrico de osteoporosis${diagnosticSite ? "; requiere valoración clínica profesional" : ", aunque el cuerpo entero no es un sitio diagnóstico y debe confirmarse en cadera o columna"}.`,
    };
  }
  if (score < -1) {
    return {
      status: "attention",
      title: `${label}: ${scoreLabel} ${format(score, 1)}`,
      text: `DMO: ${format(bmd, 3, " g/cm²")}. El T-score se encuentra en el intervalo de masa ósea baja${diagnosticSite ? " (osteopenia)" : "; la clasificación diagnóstica debe basarse en cadera o columna"}.`,
    };
  }
  return {
    status: "favorable",
    title: `${label}: ${scoreLabel} ${format(score, 1)}`,
    text: `DMO: ${format(bmd, 3, " g/cm²")}. El T-score está dentro de la normalidad${score <= -0.5 ? ", próximo al límite inferior" : ""}${diagnosticSite ? "" : "; se informa como comparación y no reemplaza la lectura central"}.`,
  };
}

export function buildDexaInterpretation(input) {
  const record = deriveDexaRecord(input);
  const total = record.composition.total;
  const indices = record.composition.indices;
  const age = toFiniteNumber(record.patient.age);
  const pediatric = age !== null && age < 18;
  const bmi = classifyBmi(indices.bmi, age);
  const referenceRange = bodyFatReference(
    record.patient.sex,
    record.patient.age,
    record.professional.populationProfile,
  );
  const leanReferenceRange = leanPercentReference(
    record.patient.sex,
    record.patient.age,
    record.professional.populationProfile,
  );
  const fatFreePercent = isFiniteNumber(total.leanPlusBmcPercent)
    ? total.leanPlusBmcPercent
    : total.leanPercent;
  const fatClassification = classifyAgainstRange(total.fatPercent, referenceRange);
  const leanClassification = classifyAgainstRange(fatFreePercent, leanReferenceRange);
  const fatReferenceRow = bodyFatReferenceRow(
    record.patient.sex,
    record.patient.age,
    record.professional.populationProfile,
    total.fatPercent,
  );
  const bone = boneInterpretation(record);
  const armSymmetry = differenceInterpretation(
    record.derived.arms,
    "Brazos",
    record.composition.regions.leftArm,
    record.composition.regions.rightArm,
    record,
  );
  const legSymmetry = differenceInterpretation(
    record.derived.legs,
    "Piernas",
    record.composition.regions.leftLeg,
    record.composition.regions.rightLeg,
    record,
  );
  const vatAvailable = isFiniteNumber(indices.vatAreaCm2);
  const vatClassification = pediatric
    ? { id: "unavailable", label: "Lectura descriptiva por edad", status: "unavailable" }
    : classifyVatArea(indices.vatAreaCm2);
  const fmiInterpretation = pediatric
    ? { status: "unavailable", label: "Lectura descriptiva por edad", note: "En menores se evita aplicar automáticamente el rango adulto de IMG." }
    : classifyFmi(indices.fmi, record.patient.sex);
  const trunkExtremity = pediatric
    ? { status: "unavailable", label: "Lectura descriptiva por edad", note: "" }
    : classifyTrunkExtremity(indices.trunkExtremityFatRatio);
  const lmiThreshold = pediatric
    ? null
    : record.patient.sex === "female" ? 16 : record.patient.sex === "male" ? 20 : null;
  const lmiRiskThreshold = pediatric
    ? null
    : record.patient.sex === "female" ? 13 : record.patient.sex === "male" ? 15 : null;
  const almiThreshold = pediatric
    ? null
    : record.patient.sex === "female" ? 6 : record.patient.sex === "male" ? 8 : null;
  const immInterpretation = musclePercentileInterpretation(
    indices.lmi,
    indices.lmiPercentileAgeMatched,
    "IMM",
    { cutoff: lmiThreshold, riskCutoff: lmiRiskThreshold, explainPercentile: true },
  );
  const immaInterpretation = musclePercentileInterpretation(
    indices.almi,
    indices.almiPercentileAgeMatched,
    "IMMA",
    { cutoff: almiThreshold, explainPercentile: false },
  );
  const almiLow = isFiniteNumber(indices.almi)
    && almiThreshold !== null
    && Number(indices.almi) < almiThreshold;
  const almiStatus = !isFiniteNumber(indices.almi) || almiThreshold === null
    ? "unavailable"
    : almiLow ? "attention" : "favorable";
  const lmiAtRisk = isFiniteNumber(indices.lmi)
    && lmiRiskThreshold !== null
    && Number(indices.lmi) <= lmiRiskThreshold;
  const regionalRows = regionalBmdRows(record);
  const regional = regionalBmdInterpretations(record);
  const regionalRecommendation = regionalExerciseRecommendations(regionalRows);
  const regionalMinimum = toFiniteNumber(record.professional.regionalBmdReferenceMin) ?? 0.97;
  const regionalMaximum = toFiniteNumber(record.professional.regionalBmdReferenceMax) ?? 1.28;
  const wholeBodyClassification = classifyAgainstRange(
    record.bone.wholeBody.bmd,
    [regionalMinimum, regionalMaximum],
  );
  const hipSideLabel = record.bone.hip.side === "right" ? "Cadera derecha" : "Cadera izquierda";
  const scoreMode = bone.mode === "t" ? "t" : "z";
  const wholeBodyScoreInterpretation = scoreSiteInterpretation(
    record.bone.wholeBody,
    "Cuerpo entero",
    scoreMode,
    { diagnosticSite: false },
  );
  const hipInterpretation = scoreSiteInterpretation(record.bone.hip.total, hipSideLabel, scoreMode);
  const lumbarInterpretation = scoreSiteInterpretation(record.bone.lumbar.total, "Columna L1-L4", scoreMode);
  const leanLevel = bodyTissueLevel(leanClassification);
  const fatLevel = bodyTissueLevel(fatClassification);
  const profileLabel = record.professional.populationProfile === "athlete"
    ? "deporte y fitness"
    : record.professional.populationProfile === "general" ? "salud general" : "el perfil pendiente";
  const vatAreaNote = pediatric
    ? "El VAT por área se conserva como dato descriptivo del equipo. En menores de edad no se aplica automáticamente el punto operativo adulto configurado."
    : `El área estimada es ${format(indices.vatAreaCm2, 1, " cm²")}: ${vatClassification.label.toLocaleLowerCase("es")} según la escala visual operativa del informe (10-100 normal, >100-160 aumentado y >160-300 alto). Esta escala facilita la lectura, pero no constituye por sí sola un umbral diagnóstico validado.`;
  const vatMassNote = pediatric
    ? "La masa de tejido adiposo visceral se conserva como dato descriptivo y requiere referencias pediátricas específicas."
    : isFiniteNumber(indices.vatMassG)
      ? `En cuanto a la masa, el valor es ${format(indices.vatMassG, 0, " g")} y ${vatClassification.id === "normal" ? "se encuentra dentro del rango normal, en concordancia con la clasificación por área" : `acompaña una clasificación por área ${vatClassification.label.toLocaleLowerCase("es")}`}.`
      : "La masa de tejido adiposo visceral no fue identificada en el informe del equipo.";
  const fmiPercentile = percentileSentence(indices.fmiPercentileAgeMatched, "Comparación del IMG", record);
  const adiposityPercentileGuidance = isFiniteNumber(indices.fmiPercentileAgeMatched)
    ? "En los índices de adiposidad, un percentil más bajo suele representar menor masa grasa relativa; su lectura debe contextualizarse con el perfil clínico y deportivo. Para la distribución tronco/extremidades, un valor y un percentil más bajos suelen reflejar menor concentración central relativa de grasa."
    : "La distribución central de grasa debe interpretarse junto con el perfil clínico y deportivo; valores más bajos de tronco/extremidades suelen reflejar una proporción cardiometabólica más favorable.";

  const conclusion = record.professional.conclusionOverride || [
    `La composición corporal registra ${format(total.fatPercent, 1, "%")} de grasa y ${format(total.leanMassKg, 1, " kg")} de masa magra.`,
    `${armSymmetry.title} y ${legSymmetry.title.toLocaleLowerCase("es")}.`,
    vatAvailable
      ? `El área de tejido adiposo visceral estimada es ${format(indices.vatAreaCm2, 1, " cm²")} (${vatClassification.label.toLocaleLowerCase("es")}).`
      : "El área de tejido adiposo visceral no fue identificada.",
    lmiAtRisk
      ? `IMM ${format(indices.lmi, 2, " kg/m²")}: riesgo operativo de sarcopenia para ${record.patient.sex === "female" ? "mujeres" : "hombres"}; priorizar evaluación de fuerza y desempeño físico.`
      : null,
    bone.text,
  ].filter(Boolean).join(" ");

  return {
    record,
    bmi,
    headline: {
      fat: {
        status: fatClassification.id === "within" ? "favorable" : fatClassification.id === "unavailable" ? "unavailable" : "attention",
        label: "Grasa corporal",
        value: format(total.fatPercent, 1, "%"),
        detail: referenceRange
          ? `${fatClassification.label}; referencia ${referenceRange[0]}–${referenceRange[1]}%`
          : "Sin rango seleccionado",
      },
      lean: {
        status: "neutral",
        label: "Masa libre de grasa",
        value: format(total.leanPlusBmcKg, 1, " kg"),
        detail: `${format(fatFreePercent, 1, "%")} de la masa DXA`,
      },
      vat: {
        status: vatClassification.status,
        label: "Grasa visceral estimada",
        value: format(indices.vatAreaCm2, 1, " cm²"),
        detail: pediatric
          ? "Dato descriptivo; sin umbral adulto automático"
          : vatClassification.label,
      },
      bone: {
        status: bone.status,
        label: bone.mode === "t"
          ? "Puntuación T central"
          : bone.mode === "z"
            ? "Puntuación Z central"
            : "Criterio óseo pendiente",
        value: format(bone.score, 1),
        detail: bone.title,
      },
    },
    bodyComposition: {
      referenceRange,
      referenceRow: fatReferenceRow,
      classification: fatClassification,
      leanReferenceRange,
      fatFreePercent,
      leanClassification,
      percentile: percentileSentence(
        indices.bodyFatPercentileAgeMatched,
        "El porcentaje de grasa",
        record,
      ),
      scanSummary: `El escaneo corporal muestra una proporción ${leanLevel} para ${profileLabel} (${format(fatFreePercent, 1, "%")}${leanReferenceRange ? `; referencia ${leanReferenceRange[0]}-${leanReferenceRange[1]}%` : ""}) de masa libre de grasa, compuesta por tejido magro —con predominio del color rojo— y contenido mineral óseo. La cantidad de tejido graso es ${fatLevel} (${format(total.fatPercent, 1, "%")}) y se representa en amarillo. La masa DXA total es ${format(total.totalMassKg, 1, " kg")}.`,
      comparison: `${fatClassification.label}${referenceRange ? ` (${referenceRange[0]}-${referenceRange[1]}%)` : ""}.${percentileSentence(indices.bodyFatPercentileAgeMatched, "Comparación por edad y sexo", record) ? ` ${percentileSentence(indices.bodyFatPercentileAgeMatched, "Comparación por edad y sexo", record)}` : ""}`,
    },
    symmetry: {
      arms: armSymmetry,
      legs: legSymmetry,
    },
    adiposity: {
      fmi: {
        value: indices.fmi,
        ...fmiInterpretation,
        percentile: percentileSentence(indices.fmiPercentileAgeMatched, "El índice de masa grasa", record),
      },
      androidGynoidRatio: indices.androidGynoidRatio,
      trunkLegFatRatio: indices.trunkLegFatRatio,
      trunkExtremityFatRatio: indices.trunkExtremityFatRatio,
      trunkExtremity,
      vat: {
        massG: indices.vatMassG,
        volumeCm3: indices.vatVolumeCm3,
        areaCm2: indices.vatAreaCm2,
        referenceAreaCm2: 100,
        status: vatClassification.status,
        classification: vatClassification,
        areaNote: vatAreaNote,
        massNote: vatMassNote,
        note: `${vatAreaNote} ${vatMassNote}`,
      },
      summary: [fmiInterpretation.note, fmiPercentile, trunkExtremity.note, adiposityPercentileGuidance].filter(Boolean).join(" "),
      education: "La cantidad total de grasa no cuenta toda la historia: también importa dónde se almacena. La grasa subcutánea se localiza bajo la piel, mientras que la grasa visceral rodea los órganos abdominales y, cuando se acumula en exceso, se asocia con mayor riesgo cardiometabólico. La relación androide/ginoide compara la grasa de abdomen y cintura con la de caderas y muslos; un predominio androide sugiere una distribución más central. Estos resultados orientan la valoración, pero deben interpretarse junto con antecedentes, presión arterial, perfil lipídico, glucemia y criterio profesional.",
    },
    muscle: {
      lmi: indices.lmi,
      lmiPercentile: percentileSentence(indices.lmiPercentileAgeMatched, "El índice de masa magra", record),
      imm: immInterpretation,
      lmiThreshold,
      lmiRiskThreshold,
      appendicularLeanMassKg: indices.appendicularLeanMassKg,
      almi: indices.almi,
      imma: immaInterpretation,
      almiThreshold,
      status: [immInterpretation.status, immaInterpretation.status, almiStatus].includes("review")
        ? "review"
        : [immInterpretation.status, immaInterpretation.status, almiStatus].includes("attention")
          ? "attention"
          : almiStatus === "unavailable" ? immaInterpretation.status : almiStatus,
      note: pediatric
        ? "El IMMA se presenta como dato descriptivo y percentil del equipo. No se aplica el punto operativo adulto de sarcopenia en menores de edad."
        : almiThreshold === null
        ? "Se necesita confirmar el sexo de referencia para aplicar el punto operativo de IMMA. La masa por sí sola no confirma ni descarta sarcopenia."
        : almiLow
          ? `El IMMA está por debajo del mínimo operativo de ${format(almiThreshold, 1, " kg/m²")}. Se recomienda evaluar fuerza y desempeño físico; este resultado aislado no diagnostica sarcopenia.`
          : `El IMMA cumple el mínimo operativo de ${format(almiThreshold, 1, " kg/m²")}. La masa por sí sola no confirma ni descarta sarcopenia.`,
      percentile: percentileSentence(indices.almiPercentileAgeMatched, "El índice de masa magra apendicular", record),
    },
    bone: {
      ...bone,
      wholeBodyBmd: record.bone.wholeBody.bmd,
      wholeBodyClassification,
      wholeBodyScore: wholeBodyScoreInterpretation,
      regional,
      regionalRows,
      regionalReference: [regionalMinimum, regionalMaximum],
      regionalRecommendation,
      hip: hipInterpretation,
      lumbar: lumbarInterpretation,
      fraxReported: record.bone.hip.fraxReported,
      fraxReason: record.bone.hip.fraxReason,
    },
    conclusion,
    sources: pediatric
      ? interpretationSources.filter((source) => source.id !== "iscd-2023")
      : interpretationSources.filter((source) => source.id !== "iscd-pediatric-2019"),
    generatedAt: new Date().toISOString(),
  };
}

export const interpretationInternals = {
  bodyFatReference,
  leanPercentReference,
  bodyFatReferenceRow,
  classifyAgainstRange,
  selectBoneMode,
  lowestCentralScore,
  boneInterpretation,
  classifyVatArea,
  classifyFmi,
  classifyTrunkExtremity,
  musclePercentileInterpretation,
  scoreSiteInterpretation,
  classifyBmi,
  round,
};
